export enum PostHogEvent {
  UI_SIDEBAR_CLICK = 'ui_sidebar_click',
  UI_DRAWER_TOGGLE = 'ui_drawer_toggle',
  AUTH_LOGIN = 'auth_login',
  AUTH_LOGOUT = 'auth_logout',
  SCREEN_VIEW = 'screen_view',
}

export enum PostHogPersonProperty {
  EMAIL = 'email',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  DATA_SOURCE = 'data_source',
  DATA_SOURCE_HASHID = 'data_source_hashid',
  PERMISSIONS = 'permissions',
  PERMISSIONS_COUNT = 'permissions_count',
}
